module.exports = __webpack_public_path__ + "img/carte.b71af848.png";